import _ from 'lodash';
import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { Input, IInputProps, TextArea } from '@cb/apricot-react';

import { FORM_ERROR_MAPPING } from 'src/constants';
import Typography from './Typography';

interface ITextInputFieldProps extends IInputProps {
  comment?: string;
  name: string;
  placeholder?: string;
  readOnly?: boolean;
  validator?: any;
}

const TextInputField: FC<ITextInputFieldProps> = ({
  comment,
  maxLength,
  multiple,
  name,
  label,
  placeholder,
  readOnly,
  validator,
  className,
  required,
  type,
  step,
}) => {
  const {
    formState: { errors },
    register,
  } = useFormContext();

  const errorType = _.get(errors, `${name}.type`) as unknown as string;
  const originalErrorMessage = _.get(errors, `${name}.message`) as unknown as string;

  let errorMessage = (errorType ? (FORM_ERROR_MAPPING[errorType] ?? originalErrorMessage) : undefined);
  if (errorType === 'validate') {
    errorMessage = (validator?.validationMessage || errorMessage);
  }

  return (
    <>
      {multiple ? (
        <TextArea
          className={className}
          floating={false}
          label={label}
          maxLength={maxLength}
          readOnly={readOnly}
          required={required}
          validation={errorMessage ? 'error' : undefined}
          validationMsg={errorMessage}
          placeholder={placeholder}
          {...register(name, {
            ...(required ? { required: 'Input is required.' } : {}),
            ...(validator || {}),
          })}
        />
      ) : (
        <Input
          clearable={type !== 'number' && type !== 'date' && !readOnly}
          className={className}
          floating={false}
          label={label}
          maxLength={maxLength}
          type={type}
          readOnly={readOnly}
          required={required}
          validation={errorMessage ? 'error' : undefined}
          validationMsg={errorMessage}
          placeholder={placeholder}
          step={step || undefined}
          {...register(name, {
            ...(required ? { required: 'Input is required.' } : {}),
            ...(validator || {}),
          })}
        />
      )}
      {comment ? <Typography variant="body1">{comment}</Typography> : null}
    </>
  );
};

export default TextInputField;
